import { Box, Typography } from '@mui/material';
import { EMPTY_VALUE, type JobOrderSpec } from '../../../utils/jobOrder';
import {
  PRINT_FONT_SIZE,
  PRINT_SIZE_FIELDS_PER_ROW,
  mutedLabelTypographySx,
  valueTypographySx,
} from '../printStyles';
import LabelCell from './LabelCell';
import { summaryCellSx, summaryValueSx } from './styles';

interface SizeRowProps {
  size: JobOrderSpec['size'];
}

const SizeRow = ({ size }: SizeRowProps) => (
  <>
    <LabelCell>Size</LabelCell>
    <Box
      sx={{
        ...summaryCellSx,
        gridColumn: '2 / -1',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 0.75,
      }}
    >
      {size ? (
        <>
          <Typography
            sx={{
              fontWeight: 700,
              textTransform: 'uppercase',
              color: 'text.secondary',
              maxWidth: '100%',
              minWidth: 0,
              overflowWrap: 'break-word',
              lineHeight: 1.2,
            }}
          >
            {size.label ?? EMPTY_VALUE}
          </Typography>
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: `repeat(${PRINT_SIZE_FIELDS_PER_ROW}, minmax(0, 1fr))`,
              alignItems: 'center',
              columnGap: 2,
              rowGap: 0.5,
              width: '100%',
            }}
          >
            {size.fields.map(({ label, value }) => (
              <Box
                key={label}
                sx={{
                  display: 'flex',
                  alignItems: 'baseline',
                  gap: 0.75,
                  minWidth: 0,
                }}
              >
                <Typography sx={mutedLabelTypographySx}>{label}</Typography>
                <Typography
                  sx={{
                    ...valueTypographySx,
                    fontSize: PRINT_FONT_SIZE.measurement,
                    whiteSpace: 'nowrap',
                  }}
                >
                  {value}
                </Typography>
              </Box>
            ))}
          </Box>
        </>
      ) : (
        <Typography sx={summaryValueSx}>{EMPTY_VALUE}</Typography>
      )}
    </Box>
  </>
);

export default SizeRow;
